import { render, staticRenderFns } from "./PopupV3.vue?vue&type=template&id=2bfeb623&scoped=true&"
import script from "./PopupV3.vue?vue&type=script&lang=js&"
export * from "./PopupV3.vue?vue&type=script&lang=js&"
import style0 from "./PopupV3.vue?vue&type=style&index=0&id=2bfeb623&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfeb623",
  null
  
)

export default component.exports